import { Query } from '../../../hooks/queries'
import { useContrastQuery } from '../../../hooks/use-contrast-query'
import { getAppExclusion } from './requests/get-app-exclusion'
import { Exclusion, ExclusionRequestArgs } from './requests/shared'

export function useAppExclusion(
  organizationUuid: string,
  applicationId: string,
  exclusionId: string
) {
  return useContrastQuery<ExclusionRequestArgs, Exclusion>(
    [Query.APP_EXCLUSION, organizationUuid, applicationId, exclusionId],
    getAppExclusion,
    {
      organizationUuid,
      applicationId,
      exclusionId
    },
    {
      cacheTime: 0
    }
  )
}
